var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddBlack = function SvgAddBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333333,9.16666667 L10.8333333,9.16666667 L10.8333333,4.16666667 C10.8333333,3.70583333 10.46,3.33333333 10,3.33333333 C9.54,3.33333333 9.16666667,3.70583333 9.16666667,4.16666667 L9.16666667,9.16666667 L4.16666667,9.16666667 C3.70666667,9.16666667 3.33333333,9.53916667 3.33333333,10 C3.33333333,10.4608333 3.70666667,10.8333333 4.16666667,10.8333333 L9.16666667,10.8333333 L9.16666667,15.8333333 C9.16666667,16.2941667 9.54,16.6666667 10,16.6666667 C10.46,16.6666667 10.8333333,16.2941667 10.8333333,15.8333333 L10.8333333,10.8333333 L15.8333333,10.8333333 C16.2933333,10.8333333 16.6666667,10.4608333 16.6666667,10 C16.6666667,9.53916667 16.2933333,9.16666667 15.8333333,9.16666667",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.500000, -1.500000), scale(0.8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#000",
    xlinkHref: "#path-1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-black.2be2fe28.svg";
export { ForwardRef as ReactComponent };